<app-header title="Party Signup"></app-header>
<div class="mt-5 pt-5">
    <div class="d-flex justify-content-between align-items-center mb-4 ml-2 ml-4">   
        <div (click)="router.navigateByUrl('/manage/party-signup/list')">
            <a type="button" 
            class="body-2"
            style="
            cursor: pointer;
            color: #007bff;
            "
            routerLink="/manage/party-signup/list"
            >
            <i class="fas fa-chevron-left mr-1"></i>
            Back to campaigns list
        </a>
        </div>   
    </div>
    <div class="mb-4 mr-4 ml-4">
        <div class="align-items-center d-flex justify-content-between">
            <div>
                <h1 class="p-0 headline-4 mr-2">{{nameProperty}}</h1>
            </div>
            <ul class="d-flex flex-row justify-content-end actions-list list-group" style="height: 36px;" >
                <li
                    class="list-group-item list-group-item--auction d-flex cursor--pointer noDetaisClick">
                <app-party-signup-popover class="noDetaisClick" [campaignId]="selectedPartySignupId">
                    <span class="noDetaisClick ml-1 pointer body-1">Download Bid Sheets</span>
                </app-party-signup-popover>
                </li>
               
            </ul> 
        </div>
        <span class="body-2 d-flex mb-3" style="color: #676767;">Last Updated On {{updatedOnProperty| date:'MMM dd, yyyy'}}</span>
    </div>

    <div>
        <div id="partySignupReportNoCampaign" class="text-center no-data-text" style="display:none; margin-top: 10em;">
            No party signup campaign
        </div>
        <div id="managePartySignupCampaignData">
            <ul class="nav nav-tabs md-tabs md-tabs--paybee paybee-modal-header--regular px-4 py-0" role="tablist">
                <li class="nav-item">
                    <a class="nav-link" id="paidTabNav" data-fragment="paidTab" href="#paidTab" role="tab" aria-controls="paidTab"
                       aria-selected="true">Paid</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="pendingsTabNav" data-fragment="pendingsTab" href="#pendingsTab" role="tab" aria-controls="pendingsTab"
                       aria-selected="true">Pending</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="remindersTabNav" data-fragment="remindersTab" href="#remindersTab" role="tab" aria-controls="remindersTab"
                       aria-selected="true">Reminders</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="promoCodesTabNav" data-fragment="promoCodesTab" href="#promoCodesTab" role="tab" aria-controls="promoCodesTab"
                       aria-selected="true">Promo Codes</a>
                </li>
            </ul>
            <div class="tab-content">
                <div [ngClass]="{'active': activeTab === 'paid'}" class="tab-pane fade show" id="paidTab" role="tabpanel" aria-labelledby="paidTabNav">
                    <div class="p-4">
                        <div class="row mb-4">
                            <div class="headline-4 px-3">
                                Paid
                            </div>
                        </div>
                        <div id="campaignPartySignupDonationsReport" >
                            <div class="">          
                                <div class="table--paybee">
                                    <div class='text-center no-data-text' style="display: none" id="emptyCampaignPartySignupDonationsList">No transactions yet.</div>
                                    <table id ="campaignPartySignupDonationsList" class="table" cellspacing="0" style="width: 100%;">
                                        <thead class="thead-light">
                                        <tr id="campaignPartySignupDonationColumns">
                                            <th>Donor</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Address</th>
                                            <th>Option </th>
                                            <th>Status</th>
                                            <th>Amount</th>
                                            <th>Tax</th>
                                            <th>Date </th>
                                            <th>Method</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div [ngClass]="{'active': activeTab === 'pendings'}" class="tab-pane fade show" id="pendingsTab"  role="tabpanel" aria-labelledby="pendingsTabNav">
                    <div class="p-4">
                        <div id="campaignPartySignupDonationsReport" >
                            <div class="row justify-content-between mb-4">
                                <div class="headline-4 px-3">
                                    Pending
                                </div>
                                <div class="d-flex flex-row">
                                    <div class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none" (click)="onClickAddPending()">
                                        <div class=" d-flex justify-content-center">
                                            <svg class="mr-2" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0)">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.501 13.4966L21.0197 16.1437C20.8963 16.8225 20.5224 17.4021 20.0038 17.7941C21.0279 18.3557 21.7222 19.444 21.7222 20.6944C21.7222 22.52 20.2423 24 18.4167 24C16.5911 24 15.1111 22.52 15.1111 20.6944C15.1111 19.7695 15.491 18.9333 16.1033 18.3333H11.2856C11.8979 18.9333 12.2778 19.7695 12.2778 20.6944C12.2778 22.52 10.7978 24 8.97222 24C7.14661 24 5.66667 22.52 5.66667 20.6944C5.66667 19.4968 6.30351 18.448 7.25701 17.8681C6.80672 17.5603 6.45099 17.1149 6.25575 16.578L3.7305 9.63352C3.51827 9.04987 3.52231 8.45499 3.69132 7.92215C3.56477 7.93686 3.43605 7.94442 3.30555 7.94442C1.47995 7.94442 0 6.46448 0 4.63887C0 2.81326 1.47995 1.33331 3.30555 1.33331C5.13116 1.33331 6.61111 2.81326 6.61111 4.63887C6.61111 5.14584 6.49698 5.62616 6.29301 6.05553H9.35629C9.34106 6.25723 9.3333 6.46102 9.3333 6.66662C9.3333 7.10153 9.368 7.52834 9.4348 7.94442H8.93338C7.08281 7.94442 5.79485 9.78325 6.42727 11.5224L7.57878 14.6891C7.962 15.7429 8.96355 16.4444 10.0849 16.4444H16.8196C18.061 16.4444 19.1312 15.5893 19.4143 14.3933C20.1583 14.1934 20.8594 13.8889 21.501 13.4966ZM1.88889 4.63887C1.88889 3.85646 2.52315 3.2222 3.30555 3.2222C4.08796 3.2222 4.72222 3.85646 4.72222 4.63887C4.72222 5.42127 4.08796 6.05553 3.30555 6.05553C2.52315 6.05553 1.88889 5.42127 1.88889 4.63887ZM7.55555 20.6944C7.55555 19.912 8.18982 19.2778 8.97222 19.2778C9.75462 19.2778 10.3889 19.912 10.3889 20.6944C10.3889 21.4768 9.75462 22.1111 8.97222 22.1111C8.18982 22.1111 7.55555 21.4768 7.55555 20.6944ZM18.4167 19.2778C17.6343 19.2778 17 19.912 17 20.6944C17 21.4768 17.6343 22.1111 18.4167 22.1111C19.1991 22.1111 19.8333 21.4768 19.8333 20.6944C19.8333 19.912 19.1991 19.2778 18.4167 19.2778Z" fill="#4D4D4D"/>
                                                    <line x1="17.3333" y1="3.99996" x2="17.3333" y2="12" stroke="#4D4D4D" stroke-width="2.66667" stroke-linecap="round"/>
                                                    <line x1="21.3334" y1="7.99996" x2="13.3334" y2="7.99996" stroke="#4D4D4D" stroke-width="2.66667" stroke-linecap="round"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0">
                                                        <rect width="24" height="24" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span class="text-truncate cursor-pointer">Add to Cart</span>
                                        </div>
                                        <div class="report-section__content d-none">Add pending pledge by Campaign.</div>
                                    </div>
                                </div>
                            </div>
                            <div id="partySignupReportNoCampaign" class="text-center no-data-text" style="display:none">
                                No party signup campaign
                            </div>
                            <div class="table--paybee">
                                <div class='text-center no-data-text' style="display: none" id="emptyCampaignPartySignupPendingList">No transactions yet.</div>
                                <table id ="campaignPartySignupPendingList" class="table" cellspacing="0" style="width: 100%;">
                                    <thead class="thead-light">
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th class="text-nowrap">First Name</th>
                                        <th class="text-nowrap">Last Name</th>
                                        <th>Phone</th>
                                        <th>Address</th>
                                        <th>Option </th>
                                        <th>Status</th>
                                        <th>Amount</th>
                                        <th>Date </th>
                                        <th>
                                            <div class="d-flex align-items-center">
                                                Info
                                                <span data-toggle='popover-hover-table'
                                                    data-trigger='hover'
                                                    data-placement='right'
                                                    title='{{selectedPartySignup?.additionalInfoDesc}}'
                                                    class='ml-1'>
                                                    <i class='blue-text far fa-question-circle'  aria-hidden='true'></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th class="text-nowrap">
                                            <div class="d-flex align-items-center text-nowrap">
                                                Info Selected
                                                <span data-toggle='popover-hover-table'
                                                    data-trigger='hover'
                                                    data-placement='right'
                                                    title='{{selectedPartySignup?.additionalInfoSelectDesc}}'
                                                    class='ml-1'>
                                                    <i class='blue-text far fa-question-circle'  aria-hidden='true'></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div [ngClass]="{'active': activeTab === 'reminders'}" class="tab-pane fade show" id="remindersTab" data-page="scheduleReminder" role="tabpanel" aria-labelledby="remindersTabNav">
                    <div class="p-4">
                        <div class="accordion md-accordion" id="scheduleReminderAccordion" style="border:none !important;" role="tablist" aria-multiselectable="true">
    
                            <div class="d-flex align-items-center justify-content-between mb-3">
                                <div class="headline-4 px-3">Reminders</div>
                                <div class="d-flex align-items-end flex-column">
                                    <div class="d-flex">
                                        <div id="sendReminderToggle" class="mb-2">
                                            <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">
                                                <i class="fas fa-paper-plane mr-2"></i>
                                                <span class="mr-2">Send now</span>
                                                <i class="fas fa-caret-down"></i>
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-right">
                                                <li class="dropdown-item body-1" id="sendPartySignupReminderRemTab"><a>Send Party Reminders To All...</a></li>
                                                <li class="dropdown-item body-1" id="sendPartySignupReminderToHostRemTab"><a>Send Party Reminder To Host...</a></li>
                                            </ul>
                                        </div>
                                        <div  class="mb-2">
                                            <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 shadow-none">
                                                <i class="fas fa-paper-plane mr-2"></i>
                                                <span class="mr-2">Schedule</span>
                                                <i class="fas fa-caret-down"></i>
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-right">
                                                <li data-id="scheduleCustomReminder_14" data-task-type="14" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                                    <a>Send Party Reminders To All...</a>
                                                </li>
                                                <li data-id="scheduleCustomReminder_15" data-task-type="15" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                                    <a>Send Party Reminder To Host...</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div id="eventDateTime" class="body-1"></div>
                                </div>
                            </div>
        
                            <div class="card" data-section="suggestedReminderCard">
                                <div class="card-header px-1" role="tab" id="suggestedReminderHeading" data-section="suggestedReminderHeading">
                                    <a id="suggestedReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#suggestedReminderCollapse" aria-expanded="false" aria-controls="suggestedReminderCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Suggested</span>
                                    </a>
                                </div>
        
                                <div id="suggestedReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="suggestedReminderHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="recommendationListContainer" data-section="suggestedReminderListContainer"></div>
                                    </div>
                                </div>
                            </div>
        
                            <div class="card" data-section="scheduledReminderCard">
                                <div class="card-header px-1" role="tab" id="scheduledReminderHeading" data-section="scheduledReminderHeading">
                                    <a id="scheduledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#scheduledReminderCollapse" aria-expanded="false" aria-controls="scheduledReminderCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Scheduled</span>
                                    </a>
                                </div>
        
                                <div id="scheduledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="scheduledReminderHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="scheduledListContainer" data-section='scheduledReminderListContainer'></div>
                                    </div>
                                </div>
                            </div>
        
                            <div class="card" data-section="completedReminderCard">
                                <div class="card-header px-1" role="tab" id="completedReminderHeading" data-section="completedReminderHeading">
                                    <a id="completedReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#completedReminderCollapse" aria-expanded="false" aria-controls="completedReminderCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Completed</span>
                                    </a>
                                </div>
        
                                <div id="completedReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="completedReminderHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="completedListContainer" data-section='completedReminderListContainer'></div>
                                    </div>
                                </div>
                            </div>
        
                            <div class="card" data-section="cancelledReminderCard">
                                <div class="card-header px-1" role="tab" id="cancelledReminderHeading" data-section="cancelledReminderHeading">
                                    <a id="cancelledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#cancelledReminderCollapse" aria-expanded="false" aria-controls="cancelledReminderCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Cancelled</span>
                                    </a>
                                </div>
        
                                <div id="cancelledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="cancelledReminderHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="cancelledListContainer" data-section='cancelledReminderListContainer'></div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div [ngClass]="{'active': activeTab === 'promoCodes'}" class="tab-pane fade show" id="promoCodesTab"  role="tabpanel" aria-labelledby="promoCodesTabNav">
                    <div class="p-4">
                        <div class="accordion md-accordion" style="border:none !important;" role="tablist" aria-multiselectable="true">
                            <div class="d-flex align-items-center justify-content-between mb-4">
                                <div class="headline-4 px-3">Promo Codes</div>
                                <div class="d-flex align-items-center">
                                    <button id="createPromoCode" class="btn btn--paybee btn--purple button waves-effect waves-light">Create Promo Code...</button>
                                </div>
                            </div>
        
                            <div class="card" id="activePromoCodeCard" data-section="activePromoCodeCard">
                                <div class="card-header px-1" role="tab" id="activePromoCodeHeading" data-section="activePromoCodeHeading">
                                    <a id="activePromoCodeHeadingLink" class="accordion-button--scheduller" data-toggle="collapse" href="#activePromoCodeCollapse" aria-expanded="true" aria-controls="activePromoCodeCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Active</span>
                                    </a>
                                </div>
        
                                <div id="activePromoCodeCollapse" class="collapse show" role="tabpanel" aria-labelledby="activePromoCodeHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="activePromoCodeContainer" data-section="activePromoCodeContainer"></div>
                                    </div>
                                </div>
                            </div>
        
                            <div class="card" id="inactivePromoCodeCard" data-section="inactivePromoCodeCard">
                                <div class="card-header px-1" role="tab" id="inactivePromoCodeHeading" data-section="inactivePromoCodeHeading">
                                    <a id="inactivePromoCodeHeadingLink" class="accordion-button--scheduller" data-toggle="collapse" href="#inactivePromoCodeCollapse" aria-expanded="true" aria-controls="inactivePromoCodeCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Inactive</span>
                                    </a>
                                </div>
        
                                <div id="inactivePromoCodeCollapse" class="collapse show" role="tabpanel" aria-labelledby="inactivePromoCodeHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="inactivePromoCodeContainer" data-section="inactivePromoCodeContainer"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
    <div #container></div>
 </div>